import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './style.scss';

class EntriesSorter extends Component {
  static propTypes = {
    id: PropTypes.string,
    isLoadingEntries: PropTypes.bool,
    tooltipEnding: PropTypes.string,
    onSort: PropTypes.func.isRequired,
    sortBy: PropTypes.shape({
      ordering_column_id: PropTypes.string,
      ordering: PropTypes.string,
    }),
  };

  handleSortAscending = () => {
    if (!this.props.isLoadingEntries) {
      this.props.onSort(this.props.id, false);
    }
  };

  handleSortDescending = () => {
    if (!this.props.isLoadingEntries) {
      this.props.onSort(this.props.id, true);
    }
  };

  render() {
    const { id, sortBy, tooltipEnding } = this.props;

    /* eslint-disable jsx-a11y/anchor-has-content */
    /* eslint-disable jsx-a11y/anchor-is-valid */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */

    const isDesc = sortBy.ordering.indexOf('-') !== -1;
    const isActive =
      sortBy.ordering_column_id === id || sortBy.ordering.indexOf(id) >= 0;

    return (
      <div styleName="caret-container">
        <a
          styleName={cn({ 'is-active': isActive && !isDesc })}
          className="icon-triangle-arrow-up"
          title={`Sort dictionary ascending by ${tooltipEnding}`}
          onClick={this.handleSortAscending}
          data-test="sort-asc"
        />

        <a
          styleName={cn({ 'is-active': isActive && isDesc })}
          className="icon-triangle-arrow-down"
          title={`Sort dictionary descending by ${tooltipEnding}`}
          onClick={this.handleSortDescending}
          data-test="sort-desc"
        />
      </div>
    );
  }
}
export default EntriesSorter;
